import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Te ayudamos con la afiliación al adquirente",
    desc: "Gestionamos tu afiliación al adquirente (CardNet, Azul, Portal o Mio) sin costo añadido. La afiliación puede tomar un tiempo según el adquirente; nosotros te guiamos en el proceso.",
    note: "Una vez afiliado, conectar tu adquirente toma 1 minuto.",
  },
  {
    n: "02",
    title: "Configura tus planes y clientes",
    desc: "Sube tu catálogo, define planes de membresía y ajusta las frecuencias de cobro que necesitas.",
  },
  {
    n: "03",
    title: "Comparte tu enlace y cobra",
    desc: "Envía el checkout personalizado a tus clientes. El sistema cobra, reintenta y avisa. Tú te enfocas en crecer.",
  },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const yBlob = useTransform(scrollYProgress, [0, 1], ["-20%", "20%"]);

  return (
    <section
      id="how"
      ref={ref}
      data-testid="how-it-works"
      className="relative py-8 md:py-12 bg-[#111111] text-white overflow-hidden"
    >
      <motion.div
        style={{ y: yBlob }}
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-[#a68a6d]/20 blur-3xl pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative max-w-8xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          className="max-w-2xl mb-16 md:mb-20"
        >
          <span className="text-base font-bold uppercase tracking-[0.2em] text-[#111111]">
            Cómo funciona
          </span>
          <h2 className="mt-4 font-['Cabinet_Grotesk'] font-black tracking-tighter leading-[0.95] text-4xl sm:text-5xl md:text-6xl">
            Tres pasos. Cero fricción.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              data-testid={`step-${s.n}`}
              className="relative"
            >
              <div className="font-['Cabinet_Grotesk'] text-8xl md:text-9xl font-black leading-none text-white/10 mb-4">
                {s.n}
              </div>
              <h3 className="font-['Cabinet_Grotesk'] text-2xl md:text-3xl font-bold tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="text-lg leading-relaxed text-white/80 max-w-sm">
                {s.desc}
              </p>
              {s.note && (
                <p className="mt-3 text-base text-[#a68a6d] font-medium leading-relaxed max-w-sm">
                  {s.note}
                </p>
              )}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 right-0 w-16 h-px bg-white/20" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
